module.exports = __webpack_public_path__ + "img/imgdiamond.95ab8add.png";